import React from 'react';
import { Slider } from '../../ui/slider';
import { LockToggle } from './LockToggle';
import { NumericField } from './NumericField';

/** A single Scenario variable row: label + lock + slider + numeric input. */
export const VariableRow = ({
  label, value, onChange, slider, prefix, suffix, step,
  locked, onLockToggle, inputTestId, sliderTestId, lockTestId, extra,
}) => (
  <div className="mb-6">
    <div className="flex justify-between items-center mb-2">
      <div className="flex items-center gap-2">
        <label className="text-sm font-medium text-slate-700 dark:text-slate-300">{label}</label>
        <LockToggle locked={locked} onToggle={onLockToggle} label={label} testId={lockTestId} />
      </div>
      {extra && <div className="text-xs text-slate-500 dark:text-slate-400">{extra}</div>}
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-[minmax(0,1fr)_180px] gap-3 items-center">
      <Slider
        data-testid={sliderTestId}
        value={[value]}
        onValueChange={(v) => onChange(v[0])}
        min={slider.min}
        max={slider.max}
        step={slider.step}
      />
      <NumericField testId={inputTestId} value={value} onChange={onChange}
                    prefix={prefix} suffix={suffix} step={step} />
    </div>
    <div className="flex justify-between text-[10px] text-slate-400 mt-1 pr-[190px]">
      <span>{prefix}{slider.min.toLocaleString()}{suffix}</span>
      <span>{prefix}{slider.max.toLocaleString()}{suffix}</span>
    </div>
  </div>
);

export default VariableRow;
